export default __webpack_public_path__ + "static/0052-77e0abab70bbf46387219f1042bdf458.png";